import React from "react";

// Inline SVG icons
function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );
}

interface FieldSectionProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  showChevron?: boolean;
}

export function FieldSection({
  title,
  description,
  icon,
  isExpanded,
  onToggle,
  children,
}: FieldSectionProps) {
  return (
    <div className="border border-slate-200 dark:border-slate-700 rounded-lg">
      <button
        className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-slate-50 dark:hover:bg-slate-800"
        onClick={onToggle}
      >
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text text-slate-500">{description}</p>
        </div>
        <div className="flex items-center gap-2">
          {icon}
          {isExpanded ? (
            <ChevronDownIcon className="h-5 w-5" />
          ) : (
            <ChevronRightIcon className="h-5 w-5" />
          )}
        </div>
      </button>
      {isExpanded && (
        <div className="border-t p-2 border-slate-200 dark:border-slate-700">
          {children}
        </div>
      )}
    </div>
  );
}
